import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSubCategorySvg } from "./IconSubCategorySvg.mjs";
const IconSubCategory = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSubCategorySvg, ...svgProps }) });
export {
  IconSubCategory
};
